"use es6";
import { featureDefinitions } from "./definitions";

function loadFeatures(features) {
    for (const key in features) {
        featureDefinitions[key] = {
            ...featureDefinitions[key],
            ...features[key],
        };
    }
}

export { loadFeatures };
